'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var $ = require("jquery");
var Scroll = /** @class */ (function () {
    function Scroll() {
        var _this = this;
        $(window).on('scroll', function () {
            var scroll = $(window).scrollTop();
            if ($('.paramWhiteBackground').length) {
                _this.changeHeaderNavi(scroll);
            }
            if ($('.paramAboutContent').length) {
                _this.animationAbout(scroll);
            }
            if ($('.paramGreeting').length) {
                _this.animationGreeting(scroll);
            }
            if ($('.paramProfile').length) {
                _this.animationProfile(scroll);
            }
            if ($('.paramHistory').length) {
                _this.animationHistory(scroll);
            }
            if ($('.paramNews').length) {
                _this.animationNews(scroll);
            }
            if ($('.paramRecruit').length) {
                _this.animationRecruit(scroll);
            }
            if ($('.paramJob').length) {
                _this.animationJob(scroll);
            }
        });
    }
    // ヘッダーナビ変更
    Scroll.prototype.changeHeaderNavi = function (scroll) {
        var position = $('.paramWhiteBackground').offset().top;
        var height = $('.paramWhiteBackground').outerHeight();
        var steering = 20;
        var endPosition = position + height;
        if (position - steering < scroll && scroll < endPosition - steering) {
            $('.bulletHeaderNavi').attr('data-color', 'black');
        }
        else {
            $('.bulletHeaderNavi').attr('data-color', 'white');
        }
    };
    Scroll.prototype.animationAbout = function (scroll) {
        var position = $('.paramAboutContent').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletAbout').attr('data-is-animation', 'true');
        }
    };
    Scroll.prototype.animationGreeting = function (scroll) {
        var position = $('.paramGreeting').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletGreeting').attr('data-is-animation', 'true');
        }
    };
    Scroll.prototype.animationProfile = function (scroll) {
        var position = $('.paramProfile').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletProfile').attr('data-is-animation', 'true');
        }
    };
    Scroll.prototype.animationHistory = function (scroll) {
        var position = $('.paramHistory').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletHistory').attr('data-is-animation', 'true');
        }
    };
    Scroll.prototype.animationNews = function (scroll) {
        var position = $('.paramNews').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletNewsMore').attr('data-is-animation', 'true');
            $('.bulletNewsContent').attr('data-is-animation', 'true');
        }
    };
    Scroll.prototype.animationRecruit = function (scroll) {
        var position = $('.paramRecruit').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletRecruit').attr('data-is-animation', 'true');
        }
    };
    Scroll.prototype.animationJob = function (scroll) {
        var position = $('.paramJob').offset().top;
        var browserHeight = $(window).outerHeight();
        if (position - (browserHeight / 3 * 2) < scroll) {
            $('.bulletJob').attr('data-is-animation', 'true');
        }
    };
    return Scroll;
}());
exports.Scroll = Scroll;
exports.default = Scroll;
